import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import type {ILogger} from "header-bidding-client-base/modules/logger/domain/iLogger";

export interface PrebidJsBidderAdUnit<BidderAdUnitDef = unknown> {
    bidder: string;
    params: BidderAdUnitDef;
}

export abstract class PrebidJsBaseBiddersLoader {
    protected bidders: { [key: string]: IPrebidJsBidder<unknown> } = {};

    public constructor(protected logger: ILogger) {
    }

    public async registerBidders(config: HeaderBiddingConfig) {
        await Promise.all(config.biddersEnabled.map(async (bidder) => {
            try {
                await this.registerBidder(bidder, config);
                this.logger.log('Bidder registered', bidder);
            } catch (error) {
                this.logger.error('Error registering bidder', bidder, error);
            }
        }));
    }
    public getBiddersSettings(): Record<string, any> {
        return Object.values(this.bidders).reduce((acc, bidder) => {
            const settings = bidder.getBidderSettings();
            if (settings) {
                acc = {...acc, ...settings};
            }
            return acc;
        }, {});
    }

    public getBiddersAdUnits(id: number, adUnitCode: string): PrebidJsBidderAdUnit[] | Error {
        return Object.values(this.bidders)
            .map(bidder => {
                const adUnit = bidder.getAdUnit(id);
                if (!adUnit) {
                    this.logger.warn(`AdUnit ${adUnitCode} not defined for bidder ${bidder.constructor.name}`);
                    return;
                }
                return adUnit;
            })
            .filter(adUnit => !!adUnit) as PrebidJsBidderAdUnit[];
    }

    protected async registerBidder(bidder: Bidders, config: HeaderBiddingConfig) {
        throw new Error(`Bidder ${bidder} not supported`);
    }

}
